import React from 'react';

const ResourcesIntro = () => {
  return (
    <div className="text-center mb-[50px]">
      <h2
        className="text-texto-oscuro font-extrabold mb-5"
        style={{ fontSize: '2.2rem' }}
      >
        Materiales Disponibles
      </h2>
      <p
        className="text-texto-sec mx-auto"
        style={{ fontSize: '1.1rem', lineHeight: '1.8', maxWidth: '800px' }}
      >
        Hemos preparado una colección de recursos de alta calidad para acompañarte en tu
        proceso de formación y bienestar. Cada documento ha sido cuidadosamente diseñado
        por expertos para ofrecerte herramientas prácticas y conocimientos valiosos.
      </p>
    </div>
  );
};

export default ResourcesIntro;
